<div class="tabs" id="tabs-1" style="background: white;">
        
 

  <div class="form-row">
    <label style="font-weight: bold; font-size: x-large; text-align: center;">Introduction To Home Care<br />
        (Instroducion Al Cuidado Del Hogar)</label>
  
  </div><br><br>
  
  
  <form id="pcaexamform"  [formGroup]="regForm"  (ngSubmit)="step13Submitted(regForm)" > 
        
        
    <div class="container-fluid anyClass">

    <br>

    <div class="row">
            <div class="col-sm-12  col-md-12 col-lg-12 ">


<div class="form-group">



<div>
        <div class="question">
            1. Which of the following traits would be <u>undesirable</u> in home care worker.<br />
            Cuales de los rasgos siguientes seria <u>indeseable</u> en un trabajador del cuidado del hogar.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio"  formControlName="Question1"  value="1" required/> a.  Arrives on time. &#47;&#47;&#47; Llegar a tiempo. </label>
                </li>
                <li>
                    <label> <input type="radio"  formControlName="Question1"  value="2" required/> b. Treats elderly people with respect. &#47;&#47;&#47; Tratar las personas de edad avanzada con respecto. </label>
                </li>
                <li>
                    <label> <input type="radio"  formControlName="Question1"  value="3" required/> c. Spends work time watching TV. &#47;&#47;&#47; Gastar el tiempo de trabajo mirando la TV. </label>
                </li>
                <li>
                    <label> <input type="radio"  formControlName="Question1"  value="4" required/> d. Watch for unsafe conditions in the home. &#47;&#47;&#47; Mirar por condiciones peligrosas en el hogar. </label>
                </li>
            </ul>
           
        </div>
    </div>

    <div>
        <div class="question">
            2. Of the following, which might the Home Care Worker be expected to do:<br />
            De los siguientes, que se espera que el Trabajador del Cuidado del Hogar haga:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question2"  value="1" required/> a. Give Injections. &#47;&#47;&#47; Dar injecion. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question2"  value="2" required/> b. Give pills and other medications. &#47;&#47;&#47; Dar p&#237;ldoras y otras medicinas. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question2"  value="3" required/> c. Give a bed bath. &#47;&#47;&#47; Dar un bano de cama. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question2"  value="4" required/> d. Give oxygen. &#47;&#47;&#47; Dar oxigeno. </label>
                </li>
            </ul>

        </div>
    </div>
    <br />
    <div>
        <b>INSTRUCTIONS: Read the following statements. <u>Select T</u> if the statement is TRUE.  <u>Select F </u>if the statement is FALSE.</b><br />
        INSTRUCCIONES: Leer las siguientes preguntas. <u>Escriba V</u> si la repuesta es VERDADERA. <u>Escriba F</u> si la repuesta es FALSA.
    </div>
    <br />
    <div>
        <div class="question">
            3. A Home Care Worker may work with a physically disabled client.<br />
            Un Trabajador del Cuidado del Hogar puede trabajar con un cliente f&#237;sicamente incapacitado.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question3"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question3"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>
     
        </div>
    </div>


    <div>
        <div class="question">
            4. The Home Care Workers works under the direction of the family.<br />
            Los trabajadores del cuidado del hogar trabajan bajo la direcci&#243;n d&#233;la familia.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question4"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question4"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <div class="question">
            5. Problems on the job should be reported to your supervisor.<br />
            Los problemas en el trabajo deben ser informados a su supervisor.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question5"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question5"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>

        </div>
    </div>
    <br />

    <div style="text-align: center;">
        <b>WORKING WITH CLIENTS</b><br />
        TRABAJANDO CON CLIENTES
    </div>
    <br />
    <div>
        <b>INSTRUCTIONS: Select the letter of the one best answer to each question.</b><br />
        INSTRUCCIONES: Escriba la letra que mejor conteste la pregunta.
    </div>
    <br />

    <div>
        <div class="question">
            6. A Home Care Worker could help an angry person by:<br />
            Un Trabajador del Cuidado del Hogar podr&#237;a ayudar a una persona enojada por:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question6"  value="1" required/> a. Telling him that he has no reason to be angry. &#47;&#47;&#47; Decirle que el no tiene raz&#243;n para estar enojada. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question6"  value="2" required/> b. Telling him that things are not as bad as they could be. &#47;&#47;&#47; decirle que las cosas no son tan malas como podr&#237;an ser. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question6"  value="3" required/> c. Telling him to stop blaming you. &#47;&#47;&#47; Decirle que pare de culparle. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question6"  value="4" required/> d. Seeing what you could do to help. &#47;&#47;&#47; Ver lo que usted podr&#237;a hacer para ayudar. </label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <div class="question">
            7. Of the following observations, which would be important to tell your supervisor?<br />
            De las siguientes observaciones, cual seria importantes decirle a su supervisor?
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question7"  value="1" required/> a. The menu for dinner. &#47;&#47;&#47; el men&#250; para cenar. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question7"  value="2" required/> b. The activities of the client&#39;s family. &#47;&#47;&#47; La actividades de la familia del cliente. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question7"  value="3" required/> c. The new clothing the client received. &#47;&#47;&#47; La ropa nueva que el cliente recibi&#243;. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question7"  value="4" required/> d. The refusal of the client to take her medicine. &#47;&#47;&#47; La negativa del cliente para tomar su medicina. </label>
                </li>
            </ul>
 
        </div>
    </div>
    <br />
    <div>
        <b>INSTRUCTIONS: Read the following statements. <u>Select T</u> if the statement is TRUE.  <u>Select F </u>if the statement is FALSE.</b><br />
        INSTRUCCIONES: Leer las siguientes preguntas. <u>Escriba V</u> si la repuesta es VERDADERA. <u>Escriba F</u> si la repuesta es FALSA.
    </div>
    <br />
    <div>
        <div class="question">
            8. Families who live in the same neighborhood are all going to be very similar.<br />
            Las familias que viven en el mismo vecindario ser&#225;n todos muy semejante.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question8"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question8"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>
      
        </div>
    </div>

    <div>
        <div class="question">
            9. A client who has no friends or family may have a feeling of not belonging anywhere.<br />
            Un cliente que no tiene ning&#250;n amigo, ni ninguna familia, puede tener un sentimiento de no pertenecer a ning&#250;n lugar.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question9"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question9"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <div class="question">
            10. An important part of an aide&#39;s job is to motivate the client to be more independent.<br />
            Una parte importante de un trabajador del hogar es motivar al cliente para ser m&#225;s independiente.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question10"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question10"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <div class="question">
            11. Encouraging the client to plan meals helps the client to feel in control.<br />
            Alentar al cliente para planear las comidas, estos ayuda al cliente a sentirse en control.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question11"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question11"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>

        </div>
    </div>

    <div style="text-align: center;">
        <b>WORKING WITH THE ELDERLY</b><br />
        TRABAJANDO CON LOS ANCIANOS
    </div>
    <br />
    <div>
        <b>INSTRUCTIONS: Select the letter of the one best answer to each question.</b><br />
        INSTRUCCIONES: Escriba la letra que mejor conteste la pregunta.
    </div>
    <br />

    <div>
        <div class="question">
            12. If an elderly person seems to be anxious or upset, the Home Care worker should:<br />
            Si una persona de edad avanzada parece estar ansioso o disgustado, el Trabajador del Cuidado de Hogar debe:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question12"  value="1" required/> a. Encourage the client to tell you what is bothering him. &#47;&#47;&#47; Alentar al cliente a decirle lo que lo molesta. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question12"  value="2" required/> b. Tell him he has nothing to be worry about. &#47;&#47;&#47; D&#237;gale el no tiene nada porqu&#233; preocuparse. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question12"  value="3" required/> c. Discourage his family from visiting. &#47;&#47;&#47; Desaliente a su familia de visitarlo. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question12"  value="4" required/> d. Ignore him. &#47;&#47;&#47; Ignorarlo. </label>
                </li>
            </ul>

        </div>
    </div>

    <br />
    <div>
        <b>INSTRUCTIONS: Read the following statements. <u>Select T</u> if the statement is TRUE.  <u>Select F </u>if the statement is FALSE.</b><br />
        INSTRUCCIONES: Leer las siguientes preguntas. <u>Escriba V</u> si la repuesta es VERDADERA. <u>Escriba F</u> si la repuesta es FALSA.
    </div>
    <br />
    <div>
        <div class="question">
            13. Elderly people have so many problems they cannot enjoy life.<br />
            La persona de edad avanzada tienen tantos problemas que ellos no pueden disfrutar de la vida.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question13"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question13"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <div class="question">
            14. If elderly people have trouble getting around, they should be encouraged to sit all day.<br />
            Si personas de edad avanzada tienen problema viajando, ellos deben ser alentados a sentarse todos el d&#237;a.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question14"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question14"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <div class="question">
            15. Elderly people may want to talk more about their past than the present.<br />
            Las personas de edad avanzada pueden querer hablar m&#225;s acerca de su pasado que el presente.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question15"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question15"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <div class="question">
            16. A stroke can change the personality of a person.<br />
            Un ataque (golpe), puede cambiar la personalidad de una persona.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question16"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question16"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <div class="question">
            17. Elderly people who are not able to take care of their own needs should be treated like children.<br />
            La personas de edad avanzada que no son capaces de cuidar de sus propias necesidades se deben tratar como ni&#241;os.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question17"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question17"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>

        </div>
    </div>
    <br />
    <div style="text-align: center;">
        <b>WORKING WITH CHILDREN</b><br />
        TRABAJANDO CON NINOS
    </div>
    <br />
    <div>
        <b>INSTRUCTIONS: Select the letter of the one best answer to each question.</b><br />
        INSTRUCCIONES: Escriba la letra que mejor conteste la pregunta.
    </div>
    <br />

    <div>
        <div class="question">
            18. You are taking care of a pre-school child who has an imaginary friend.<br />
            You should:<br />
            Usted cuida de un ni&#241;o pre-escolar que tiene un amigo imaginario. <br />Usted debe:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question18"  value="1" required/> a. Explain that she should not be making up stories. &#47;&#47;&#47; Explique que ella no debe estar haciendo historias. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question18"  value="2" required/> b. Spank her for telling lies. &#47;&#47;&#47; Z&#250;rrela (Pegarle) por decir mentiras. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question18"  value="3" required/> c. Tell her that she is &#34;crazy&#34;. &#47;&#47;&#47; Decirle que esta &#34;loca&#34;. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question18"  value="4" required/> d. Realize that this is normal behavior. &#47;&#47;&#47; Darse cuenta de que esto es la conducta normal. </label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <div class="question">
            19. The child you are caring for is not walking or talking at the same age your child did. <br />
            You should:<br />
            El ni&#241;o que usted cuida no trabaja, camina, ni habla en la misma edad que su ni&#241;o hizo. <br />Usted debe:
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question19"  value="1" required/> a. Realize that children learn to walk at different ages. &#47;&#47;&#47; Darse cuenta que los ni&#241;os aprender a caminar a diferente edades. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question19"  value="2" required/> b. Realize that the child is probably mentally challenged. &#47;&#47;&#47; Darse cuenta de que el ni&#241;o es probablemente desafíos. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question19"  value="3" required/> c. Take the child to the doctor. &#47;&#47;&#47; Levar el ni&#241;o al doctor. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question19"  value="4" required/> d. Spank the child for being lazy. &#47;&#47;&#47; Pegarle al ni&#241;o porque es perezoso.</label>
                </li>
            </ul>

        </div>
    </div>

    <br />
    <div>
        <b>INSTRUCTIONS: Read the following statements. <u>Select T</u> if the statement is TRUE.  <u>Select F </u>if the statement is FALSE.</b><br />
        INSTRUCCIONES: Leer las siguientes preguntas. <u>Escriba V</u> si la repuesta es VERDADERA. <u>Escriba F</u> si la repuesta es FALSA.
    </div>
    <br />
    <div>
        <div class="question">
            20. A baby should be talked to even if he/she doesn&#39;t understand what you are saying.<br />
            Un bebe debe de habl&#225;rsele incluso si el/ella no entiende lo que se le dice.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question20"  value="1" required/> T  &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question20"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>
  
        </div>
    </div>

    <div>
        <div class="question">
            21. Two year old children who do not do what you want them to are &#34;bad&#34;.<br />
            Los ni&#241;os de dos anos de edad que no hacen lo que usted quiere que ellos hagan son &#34;malos&#34;.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question21"  value="1" required/> T  &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question21"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>
    
        </div>
    </div>

    <div>
        <div class="question">
            22. A child who is afraid of the dark is mentally ill.<br />
            Un ni&#241;o que tiene miedo a la oscuridad esta mentalmente enfermo.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question22"  value="1" required/> T  &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question22"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>

        </div>
    </div>
    <br />
    <div style="text-align: center;">
        <b>WORKING WITH THE MENTALLY ILL</b><br />
        TRABAJAR CON LOS ENFERMOS MENTALES
    </div>
    <br />
    <div>
        <b>INSTRUCTIONS: Select the letter of the one best answer to each question.</b><br />
        INSTRUCCIONES: Escriba la letra que mejor conteste la pregunta.
    </div>
    <br />

    <div>
        <div class="question">
            23. An indication of mental illness is:<br />
            Una indicaci&#243;n de la enfermedad mental es:<br />
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question23"  value="1" required/> a. Not liking to cook. &#47;&#47;&#47; No gustarle cocinar. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question23"  value="2" required/> b. Never bathing, combing one&#39;s hair or changing clothes. &#47;&#47;&#47; Nunca ba&#241;arse, peinarse, ni cambiarse de ropa. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question23"  value="3" required/> c. Being upset when a pet dog dies. &#47;&#47;&#47; Sentirse trastornado cuando su perro se muere. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question23"  value="4" required/> d. Having a lot of colds. &#47;&#47;&#47; Tener muchos fr&#237;os. </label>
                </li>
            </ul>

        </div>
    </div>


    <div>
        <div class="question">
            24. When you work with mentally ill clients you should:<br />
            Cuando usted trabaja con clientes mentalmente enfermos usted deber&#237;a:<br />
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question24"  value="1" required/> a. Tell them they are not normal. &#47;&#47;&#47; Decirle que no son normales. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question24"  value="2" required/> b. Ignore them as much as possible. &#47;&#47;&#47; Ign&#243;relos mas posible. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question24"  value="3" required/> c. Tell their families to stay away. &#47;&#47;&#47; Decirles a los familiares que se ausenten. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question24"  value="4" required/> d. Treat them with understanding and patience. &#47;&#47;&#47; Tratelos con comprension y paciencia. </label>
                </li>
            </ul>

        </div>
    </div>

    <br />
    <div>
        <b>INSTRUCTIONS: Read the following statements. <u>Select T</u> if the statement is TRUE.  <u>Select F </u>if the statement is FALSE.</b><br />
        INSTRUCCIONES: Leer las siguientes preguntas. <u>Escriba V</u> si la repuesta es VERDADERA. <u>Escriba F</u> si la repuesta es FALSA.
    </div>
    <br />
    <div>
        <div class="question">
            25. Talking problems over with a professional is a way to cope with mental illness.<br />
            Hablar sobre los problemas con un profesional es una manera de enfrentarse con la enfermedad mental.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question25"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question25"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>

        </div>
    </div>
    <br />
    <div style="text-align: center;">
        <b>WORKING WIH THE MENTALLY CHALLENGED</b><br />
        TRABAJAR CON LOS DESAFÍOS MENTALMENTE
    </div>
    <br />
    <div>
        <b>INSTRUCTIONS: Select the letter of the one best answer to each question.</b><br />
        INSTRUCCIONES: Escriba la letra que mejor conteste la pregunta.
    </div>
    <br />

    <div>
        <div class="question">
            26. A severely mentally challenged teenager should be:<br />
            Un adolescente severamente desafíos  debe se:<br />
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question26"  value="1" required/> a. Treated like a normal teenager. &#47;&#47;&#47; Tratarlo como un adolescente normal. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question26"  value="2" required/> b. Isolated from the rest of the family. &#47;&#47;&#47; Aislarlo del resto de la familia. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question26"  value="3" required/> c. Given love and affection. &#47;&#47;&#47; Darle amor y cari&#241;o. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question26"  value="4" required/> d. Encouraged to read. &#47;&#47;&#47; Alentarlo a leer. </label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <div class="question">
            27. Intellectual developmental disorder may be caused by:<br />
            El trastorno del desarrollo intelectual puede ser causado por:<br />
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question27"  value="1" required/> a. Abuse of alcohol during pregnancy. &#47;&#47;&#47; El abuso de alcohol durante el embarazo. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question27"  value="2" required/> b. Poor education of the mother. &#47;&#47;&#47; La educaci&#243;n pobre de la madre. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question27"  value="3" required/> c. The mother watching too much television during pregnancy. &#47;&#47;&#47; La madre que mira demasiada televisi&#243;n durante el embarazo. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question27"  value="4" required/> d. Being neglected by the father. &#47;&#47;&#47; Siendo descuidado por el padre. </label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <b>INSTRUCTIONS: Read the following statements. <u>Select T</u> if the statement is TRUE.  <u>Select F </u>if the statement is FALSE.</b><br />
        INSTRUCCIONES: Leer las siguientes preguntas. <u>Escriba V</u> si la repuesta es VERDADERA. <u>Escriba F</u> si la repuesta es FALSA.
    </div>
    <br />
    <div>
        <div class="question">
            28. Mentally challenged children may look different from normal children.<br />
            Los ni&#241;os mentalmente desafíos pueden parecer diferentes de los ni&#241;os normales.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question28"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question28"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <div class="question">
            29. Intellectual developmental disorder can be cured by the proper treatment.<br />
            El trastorno del desarrollo intelectual se puede curar con el tratamiento adecuado.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question29"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question29"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <div class="question">
            30. Mentally challenged people have the same kind of feeling that other people have.<br />
            Las personas mentalmente desafíos tienen la misma clase de sentimiento que otras personas tienen.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question30"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question30"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>

        </div>
    </div>
    <br/>
    <div style="text-align: center;">
        <b>WORKING WITH THE PHYSICALLY DISABLED</b><br />
        TRABAJAR CON EL FISICAMENTE INCAPACITADO
    </div>
    <br />
    <div>
        <b>INSTRUCTIONS: Select the letter of the one best answer to each question.</b><br />
        INSTRUCCIONES: Escriba la letra que mejor conteste la pregunta.
    </div>
    <br />

    <div>
        <div class="question">
            31. A physical disability:<br />
            Una incapacidad f&#237;sica:<br />
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question31"  value="1" required/> a. Is an allergy. &#47;&#47;&#47; Es una alergia. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question31"  value="2" required/> b. Is always permanent. &#47;&#47;&#47; Es siempre permanente. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question31"  value="3" required/> c. Will prevent a person from leading a normal life. &#47;&#47;&#47; Prevendr&#225; a una persona de dirigir una vida normal. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question31"  value="4" required/> d. May be caused by an illness, and accident or an injury at birth. &#47;&#47;&#47; Puede ser causada por una enfermedad, y/por un accidente o una herida al nacer. </label>
                </li>
            </ul>

        </div>
    </div>


    <div>
        <div class="question">
            32. Mrs. Jones fell and broke her hip. In caring for her you should:<br />
            La Se&#241;ora Jones se cay&#243; y se rompi&#243; la cadera. Al cuidar de ella usted debe:<br />
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question32"  value="1" required/> a. Consider what she can do , can&#39;t do. &#47;&#47;&#47; Considerar que ella puede, y que no puede hacer. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question32"  value="2" required/> b. Tell her she doesn&#39;t have to worry, you will do everything for her. &#47;&#47;&#47; Decirle que ella no tiene que preocuparse, usted har&#225; todos para ella. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question32"  value="3" required/> c. Encourage her to cry it out. &#47;&#47;&#47; Alentarla a grita. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question32"  value="4" required/> d. Discourage her family from visiting. &#47;&#47;&#47; Desaliente su familia de visitarla. </label>
                </li>
            </ul>

        </div>
    </div>


    <div>
        <b>INSTRUCTIONS: Read the following statements. <u>Select T</u> if the statement is TRUE.  <u>Select F </u>if the statement is FALSE.</b><br />
        INSTRUCCIONES: Leer las siguientes preguntas. <u>Escriba V</u> si la repuesta es VERDADERA. <u>Escriba F</u> si la repuesta es FALSA.
    </div>
    <br />
    <div>
        <div class="question">
            33. A physical disability can be caused by a stroke.<br />
            Una incapacidad f&#237;sica puede ser causada por un golpe (ataque al coraz&#243;n).
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question33"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question33"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <div class="question">
            34. A person with a physical disability may lose his/her sense of self-worth.<br />
            Una persona con una incapacidad f&#237;sica puede perder su sentido del auto-valor.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question34"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question34"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <div class="question">
            35. A physically disabled person may be very angry.<br />
            Una persona f&#237;sicamente incapacitada puede estar muy enojada.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question35"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question35"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>
  
        </div>
    </div>
    <br />
    <div style="text-align: center;">
        <b>FOOD, NUTRITION AND MEAL PREPARATION</b><br />
        ALIMENTO, LA PREPARACION DE NUTRICION Y COMIDA
    </div>
    <br />
    <div>
        <b>INSTRUCTIONS: Select the letter of the one best answer to each question.</b><br />
        INSTRUCCIONES: Escriba la letra que mejor conteste la pregunta.
    </div>
    <br />

    <div>
        <div class="question">
            36. A good source of protein is:<br />
            Una fuente buena de la prote&#237;na es:<br />
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question36"  value="1" required/> a. An Orange. &#47;&#47;&#47; Naranja. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question36"  value="2" required/> b. Fish. &#47;&#47;&#47; Pescado. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question36"  value="3" required/> c. Cereal. &#47;&#47;&#47; Cereales. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question36"  value="4" required/> d. Ice Cream. &#47;&#47;&#47; Helado. </label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <div class="question">
            37. To cut down on the amount of salt in a diet, you would buy:<br />
            Para reducir la cantidad de sal en una dieta, usted comprar&#237;a:<br />
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question37"  value="1" required/> a. Fresh vegetables. &#47;&#47;&#47; Vegetales fresco. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question37"  value="2" required/> b. Canned vegetables. &#47;&#47;&#47; Vegetales enlatados. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question37"  value="3" required/> c. TV dinners. &#47;&#47;&#47; Cena de televisi&#243;n. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question37"  value="4" required/> d. Ready-prepared food. &#47;&#47;&#47; Alimento pre-preparado. </label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <div class="question">
            38. Mr. Desmonds is 79 years old. He lives alone and is on a low fat diet.
            Select the best menu from the ones below.<br />
            (El Sr. Desmond tiene 79 anos. El vive solo y esta en una dieta de bajo contenido graso. Escoja el mejor men&#250; de los de abajo).<br />
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question38"  value="1" required/> a.  Fried chicken, baked potato with butter, green beans, apple pie, whole milk. &#47;&#47;&#47; (Pollo frito, papa asada con mantequilla, habichuelas, pastel de manzana, leche entera).</label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question38"  value="2" required/> b. Baked ham, potato salad, green peas, bread and butter, chocolate ice cream. &#47;&#47;&#47; (Jamon horneado, ensalada de papa, los quisantes, el pan y la mantequilla, helado de chocolate). </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question38"  value="3" required/> c. Baked chicken, boiled potatoes with parsley, steamed carrots, fresh peaches, skim milk. &#47;&#47;&#47; (Pollo horneado, papas hervidas con perejil, zanahoria al vapor, melocotones frescos, la leche descremada). </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question38"  value="4" required/> d. Meat loaf, French fried potatoes, mixed vegetables, jello with whipped cream, tea. &#47;&#47;&#47; (Pan de carne, papas fritas, vegetales mezclado, gelatina con crema, te). </label>
                </li>
            </ul>

        </div>
    </div>


    <div>
        <div class="question">
            39. A good source of Vitamin C is:<br />
            Una fuente buena de Vitamina C es:<br />
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question39"  value="1" required/> a. Milk. &#47;&#47;&#47; Leche. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question39"  value="2" required/> b. Whole wheat bread. &#47;&#47;&#47; Pan integral. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question39"  value="3" required/> c. Grapefruit. &#47;&#47;&#47; Toronja. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question39"  value="4" required/> d. Chicken. &#47;&#47;&#47; Pollo. </label>
                </li>
            </ul>
    
        </div>
    </div>

    <div>
        <div class="question">
            40. A good source of calcium is:<br />
            Una fuente buena de calcios es:<br />
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question40"  value="1" required/> a. Macaroni. &#47;&#47;&#47; Macacores. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question40"  value="2" required/> b. Hamburger. &#47;&#47;&#47; Hamburguesa. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question40"  value="3" required/> c. Cottage Cheese. &#47;&#47;&#47; Reques&#243;n. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question40"  value="4" required/> d. Orange Juice. &#47;&#47;&#47; Jugo de Naranja. </label>
                </li>
            </ul>

        </div>
    </div>


    <div>
        <b>INSTRUCTIONS: Read the following statements. <u>Select T</u> if the statement is TRUE.  <u>Select F </u>if the statement is FALSE.</b><br />
        INSTRUCCIONES: Leer las siguientes preguntas. <u>Escriba V</u> si la repuesta es VERDADERA. <u>Escriba F</u> si la repuesta es FALSA.
    </div>
    <br />
    <div>
        <div class="question">
            41. Elderly people should have some food from the milk group every day.<br />
            La persona de edad avanzada debe tener alg&#250;n alimento del grupo de leche cada d&#237;a.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question41"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question41"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>
 
        </div>
    </div>

    <div>
        <div class="question">
            42. All elderly people have good appetites and will eat anything you prepare.<br />
            Toda persona de edad avanzada tiene los mismos apetitos buenos y comer&#225;n algo de lo que usted prepara.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question42"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question42"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <div class="question">
            43. Meat that is not going to be used in a few days should be frozen.<br />
            La carne que no se utilizara en pocos d&#237;as se debe congelar.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question43"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question43"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <div class="question">
            44. Being overweight can add to the risk of getting a stroke.<br />
            Pesar demasiado puede a&#241;adir al riesgo de obtener un ataque al coraz&#243;n.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question44"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question44"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>

        </div>
    </div>
    <br />

    <div style="text-align: center;">
        <b>FAMILY SPENDING AND BUDGETING</b><br />
        GASTO DE FAMILIA Y PRESUPUESTO
    </div>
    <br />
    <div>
        <b>INSTRUCTIONS: Select the letter of the one best answer to each question.</b><br />
        INSTRUCCIONES: Escriba la letra que mejor conteste la pregunta.
    </div>
    <br />


    <div>
        <div class="question">
            45. If the home care workers shops for the client, it would be a good idea to:<br />
            Si la trabajadora del cuidado del hogar compra para el cliente, seria una idea buena si:<br />
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question45"  value="1" required/> a. Give the change and receipts to the client. &#47;&#47;&#47; Dar el cambio y el recibo al cliente. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question45"  value="2" required/> b. Leave the change and receipts on the table. &#47;&#47;&#47; Dejar el cambio y el recibo encima de la mesa. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question45"  value="3" required/> c. Keep the change as a tip. &#47;&#47;&#47; Mantener el cambio como una prospina. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question45"  value="4" required/> d. Give the change and receipts to the supervising nurse. &#47;&#47;&#47; Darle el cambio y el recibo a la enfermera que supervisa. </label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <b>INSTRUCTIONS: Read the following statements. <u>Select T</u> if the statement is TRUE.  <u>Select F </u>if the statement is FALSE.</b><br />
        INSTRUCCIONES: Leer las siguientes preguntas. <u>Escriba V</u> si la repuesta es VERDADERA. <u>Escriba F</u> si la repuesta es FALSA.
    </div>
    <br />
    <div>
        <div class="question">
            46. The home Care worker should explain all purchases as soon as returning from shopping.<br />
            El trabajador del hogar debe explicar todas la compra tan pronto regresa de la tienda.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question46"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question46"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <div class="question">
            47. Store brands of food may cost less but have the same quality as brand name foods.<br />
            Almacenes de marca de alimento pueden costar menos, pero pueden tener la misma calidad como alimento de nombre de marca.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question47"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question47"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <div class="question">
            48. &#34;Health foods&#34; may cost more but not be any better for you than foods you buy in the market.<br />
            Los &#34;Alimentos Naturales&#34; pueden costar menos, pero pueden ser iguales que otros alimentos que usted compra en el mercado.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question48"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question48"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>

        </div>
    </div>


    <div style="text-align: center;">
        <b>CARE OF THE HOME</b><br />
        CUIDADO DEL HOGAR
    </div>
    <br />
    <div>
        <b>INSTRUCTIONS: Select the letter of the one best answer to each question.</b><br />
        INSTRUCCIONES: Escriba la letra que mejor conteste la pregunta.
    </div>
    <br />


    <div>
        <div class="question">
            49. A good way to organize cleaning is to:<br />
            Una buena manera de organizar la limpieza es:<br />
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question49"  value="1" required/> a. Clean the dirtiest part of the house first. &#47;&#47;&#47; Limpiar la parte m&#225;s sucia del hogar primero. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question49"  value="2" required/> b. Clean the part of the house that the client uses the most. &#47;&#47;&#47; Limpiar la parte del hogar que el cliente mas usa. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question49"  value="3" required/> c. Clean the bathroom first. &#47;&#47;&#47; Limpiar el ba&#241;o primero. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question49"  value="4" required/> d. Clean the kitchen first. &#47;&#47;&#47; Limpiar la cocina primero. </label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <b>INSTRUCTIONS: Read the following statements. <u>Select T</u> if the statement is TRUE.  <u>Select F </u>if the statement is FALSE.</b><br />
        INSTRUCCIONES: Leer las siguientes preguntas. <u>Escriba V</u> si la repuesta es VERDADERA. <u>Escriba F</u> si la repuesta es FALSA.
    </div>
    <br />
    <div>
        <div class="question">
            50. By keeping the bathroom clean, you can help cut down the spread of disease.<br />
            Manteniendo el cuarto del ba&#241;o limpio, usted puede ayudar a que la enfermedad no se extienda.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question50"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question50"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <div class="question">
            51. Accidents are less likely to happen in areas that are kept neat.<br />
            Los accidentes son menos probables de suceder en &#225;reas que se mantienen ordenado.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question51"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question51"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <div class="question">
            52. It may be possible to do two tasks at once such as cleaning the refrigerator and preparing lunch.<br />
            Puede ser posible hacer dos tareas inmediatamente, tal como limpiar el refrigerador y preparar el almuerzo.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question52"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question52"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>

        </div>
    </div>

    <div style="text-align: center;">
        <b>SAFETY AND ACCIDENT PREVENTION</b><br />
        SECURIDAD Y PREVENCION DE ACCIDENTES
    </div>
    <br />

    <div>
        <b>INSTRUCTIONS: Read the following statements. <u>Select T</u> if the statement is TRUE.  <u>Select F </u>if the statement is FALSE.</b><br />
        INSTRUCCIONES: Leer las siguientes preguntas. <u>Escriba V</u> si la repuesta es VERDADERA. <u>Escriba F</u> si la repuesta es FALSA.
    </div>
    <br />
    <div>
        <div class="question">
            53. Minor burns should be covered with butter.<br />
            La quemaduras menores se deben cubrir con mantequilla.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question53"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question53"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <div class="question">
            54. Turning pot handles to the back of the stove is a good safety practice.<br />
            Poner el manco de la olla para atra en la estufa, es una buena pr&#225;ctica de la seguridad.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question54"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question54"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <div class="question">
            55. Spills on the floor should be wiped up immediately to prevent accidents.<br />
            Liquido derramado en el piso, deben se limpiado inmediatamente para prevenir accidentes.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question55"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question55"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>

        </div>
    </div>

    <div style="text-align: center;">
        <b>PERSONAL CARE</b><br />
        CUIDADO PERSONAL
    </div>
    <br />
    <div>
        <b>INSTRUCTIONS: Select the letter of the one best answer to each question.</b><br />
        INSTRUCCIONES: Escriba la letra que mejor conteste la pregunta.
    </div>
    <br />


    <div>
        <div class="question">
            56. Baths should be given to the clients:<br />
            El bano deberia darsele al cliente:<br />
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question56"  value="1" required/> a. Every day. &#47;&#47;&#47; Todos los d&#237;as. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question56"  value="2" required/> b. Once a week. &#47;&#47;&#47; Una vez a la semana. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question56"  value="3" required/> c. Occasionally. &#47;&#47;&#47; Ocasionalmente. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question56"  value="4" required/> d. According to the client&#39;s needs. &#47;&#47;&#47; De acuerdo a la necesidad del cliente. </label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <div class="question">
            57. The safest way to shape the fingernails of a client is to use:<br />
            La manera mas segura de darle forma a las unas de un cliente es usando:<br />
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question57"  value="1" required/> a. A pair of nail clippers. &#47;&#47;&#47; Un par de corta unas. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question57"  value="2" required/> b. A pair of nail scissors. &#47;&#47;&#47; Un par de tijeras para unas. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question57"  value="3" required/> c. Any scissors you can find. &#47;&#47;&#47; Cualquier tijeras que pueda encontrar. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question57"  value="4" required/> d. An emery board. &#47;&#47;&#47; Una lima de unas. </label>
                </li>
            </ul>

        </div>
    </div>


    <div>
        <div class="question">
            58. In proper hand washing technique, you should:<br />
            Una tecnica apropiada de lavar la mano es:<br />
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question58"  value="1" required/> a. Wash your hands up to the palms. &#47;&#47;&#47; Lave las manos hasta las palmas. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question58"  value="2" required/> b. Raise hands so water and soap can drain down the elbow. &#47;&#47;&#47; Levantar la mano de manera que el agua y el jab&#243;n puedan ir hasta abajo del codo. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question58"  value="3" required/> c. Repeat the washing process once. &#47;&#47;&#47; Repetir el proceso de lavar la mano una vez. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question58"  value="4" required/> d. Wash the tap before turning of the water. &#47;&#47;&#47; Lave el grifo ante de girar el agua. </label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <div class="question">
            59. The skin of older people is normally:<br />
            La piel de una persona de edad avanzada es normalmente:<br />
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question59"  value="1" required/> a. Elastic. &#47;&#47;&#47; Elastica. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question59"  value="2" required/> b. Moist. &#47;&#47;&#47; Humeda. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question59"  value="3" required/> c. Thick. &#47;&#47;&#47; Gruesa. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question59"  value="4" required/> d. Easily damaged. &#47;&#47;&#47; F&#225;cilmente da&#241;ado. </label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <div class="question">
            60. When the client cannot control bladder and bowel movements, it is called:<br />
            Cuando el cliente no puede controlar la ves&#237;cula y evacuaciones, se llama:<br />
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question60"  value="1" required/> a.  Diarrhea. &#47;&#47;&#47; Diarrea. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question60"  value="2" required/>    b. Constipation. &#47;&#47;&#47; Estre&#241;imiento. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question60"  value="3" required/>   c. Urination. &#47;&#47;&#47; Micci&#243;n (orina). </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question60"  value="4" required/>   d. Incontinence. &#47;&#47;&#47; Incontinencia. </label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <div class="question">
            61. When Mr. King uses a walker, the aide should be sure Mr. King:<br />
            Cuando el cliente no puede controlar la ves&#237;cula y evacuaciones, se llama:<br />
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question61"  value="1" required/> a. Lifts the walker and moves it forward. &#47;&#47;&#47; Levante el caminador y se mueva hacia adelante. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question61"  value="2" required/> b. Moves both feet forward while leaning on the walker. &#47;&#47;&#47; Mueves ambos pies hacia adelante al inclinarse en el caminador. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question61"  value="3" required/> c. Does not bend his elbows. &#47;&#47;&#47; No doble sus codos. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question61"  value="4" required/> d. Does not place any weight on his hands while leaning on the walker. &#47;&#47;&#47; No coloque ning&#250;n peso en su manos mienta esta inclinado en el caminador. </label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <div class="question">
            62. Which should an aide do first when helping a client into a wheelchair:<br />
            Cual debe un ayudante hacer primero al ayudar a un cliente en su silla de rueda:<br />
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question62"  value="1" required/> a. Put a blanket in the wheelchair. &#47;&#47;&#47; Poner una manta en la silla de rueda. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question62"  value="2" required/> b. Lock the brakes on the wheelchair. &#47;&#47;&#47; Poner los frenos a la silla de ruedas. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question62"  value="3" required/> c. Raise the client&#39;s bed. &#47;&#47;&#47; Levantar la cama del cliente. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question62"  value="4" required/> d. Adjust the wheelchair to a comfortable angle. &#47;&#47;&#47; Ajustar la silla de rueda hacia un &#225;ngulo confortable. </label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <div class="question">
            63. Your client, Mr. Daper, has an indwelling catheter. This means:<br />
            Su paciente, El Se&#241;or Daper, tiene un cat&#233;ter que mora, esto significa que:<br />
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question63"  value="1" required/> a. It remains in the bladder. &#47;&#47;&#47; Este se mantiene en la ves&#237;cula. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question63"  value="2" required/> b. It must be removed after the bladder is emptied. &#47;&#47;&#47; Este debe ser removido despu&#233;s que la ves&#237;cula esta vac&#237;a. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question63"  value="3" required/> c. The urine does not have to be measured. &#47;&#47;&#47; La orina no tiene que se medida. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question63"  value="4" required/> d. It does not require catheter care. &#47;&#47;&#47; El cat&#233;ter no requiere cuidado. </label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <div class="question">
            64. Your confused client is sometimes incontinent of urine. Which measure will help the most to keep her dry:<br />
            Su cliente es confuso y a veces incontinente de la orina. Que medida ayudara a mantenerlo seco:<br />
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question64"  value="1" required/> a. Giving her fluids at mealtime only. &#47;&#47;&#47; Darle liquido en hora de comer solamente. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question64"  value="2" required/> b. Telling her to ask for the bedpan at frequent, regular intervals. &#47;&#47;&#47; Decirle que pregunte por el chata (cubito), cuando sienta necesidad de orinar. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question64"  value="3" required/> c. Placing her on the bedpan at frequent, regular intervals. &#47;&#47;&#47; Colocarlo en la chata (cubito) en intervalos frecuentes y regulares. </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question64"  value="4" required/> d. Keeping a large absorbent towel under her buttocks. &#47;&#47;&#47; Mantener una toalla larga absorbente bajo sus fundillos. </label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <div class="question">
            65. It is important to position the client in bed correctly because it decreases the chance of bed sore.<br />
            Es importante posicional al cliente en la cama correctamente porque esto disminuye el riesgo de llagas de cama.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question65"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question65"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <div class="question">
            66. Bending at both knees helps make lifting heavy objects easier.<br />
            Doblando ambas rodillas ayuda que levantar objectos pesado sea m&#225;s f&#225;ciles.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question66"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question66"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <div class="question">
            67. It doesn&#39;t matter whether or not the hair of elderly clients is washed regularly because they don&#39;t care how they look.<br />
            No importa si el cliente de edad avanzada se lave o no la cabeza con regularidad, porque ellos no le importa como ellos se miran.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question67"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question67"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <div class="question">
            68. While giving a back rub the Home Care Worker can look for red areas that could develop into bed sores.<br />
            Al dar una frotada en la espalda el Trabajador del cuidado del Hogar puede buscar por areas rojas que podr&#237;an convertirse en llagas de cama.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question68"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question68"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <div class="question">
            69. Brushing the teeth and good mouth care can make the client feel better.<br />
            Al mantener una buena higiene dental el cliente se siente mejor.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question69"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question69"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>

        </div>
    </div>

    <div>
        <div class="question">
            70. A clean, fresh bed is an important part of personal care.<br />
            Una cama limpia y fresca, es una parte importante del cuidado personal.
        </div>
        <div class="answers">
            <ul>
                <li>
                    <label> <input type="radio" formControlName="Question70"  value="1" required/> T &#47;&#47;&#47; V </label>
                </li>
                <li>
                    <label> <input type="radio" formControlName="Question70"  value="2" required/> F   &#47;&#47;&#47; F</label>
                </li>
            </ul>
 
        </div>
    </div>

    <hr />
 
</div>


            </div>
    </div>

  <br/>

  </div>


  <button type="button" (click) = "decreasePage()" class="btn btn-create"  matStepperPrevious><i class="ace-icon fa fa-arrow-left"></i>Prev Page</button>
  &nbsp;
  <button type="submit"  class="btn btn-primary" >Save and Continue &nbsp;
    <i class="ace-icon fa fa-arrow-right icon-on-right"></i></button>   
    

    <div class="spinner-border text-success" role="status" style="position: absolute; bottom:10;" *ngIf="isfetching === true"></div>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i className="fa fa-spinner fa-spin  fa-2x" style="color:blue" *ngIf="isfetching === true"> Saving Data...</i>

    </form>

                   
  

</div>
   